/* eslint-disable prettier/prettier */
/* eslint-disable react/display-name */

import PropTypes from 'prop-types';
import { forwardRef,useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
import Chip from '@mui/material/Chip';

// project imports
import { MENU_OPEN, SET_MENU } from 'store/actions';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const NavItem = ({ item, level }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const customization = useSelector((state) => state.customization);
    const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));
    const [hover, setHover] = useState(false);
    const hoverTimeoutRef = useRef(null); // local ref for timeout

    const handleMouseEnter = () => {
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(() => setHover(true), 50); // optional delay
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        setHover(false);
    };
    // Destructure and render the selected_icon and icon
    const SelectedIcon = item.selected_icon ? (
        <item.selected_icon style={{ width: '22px', height: '22px', marginTop: 'auto', marginBottom: 'auto' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 8 : 6,
                height: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    const ItemIcon = item.icon ? (
        <item.icon style={{ width: '22px', height: '22px', marginTop: 'auto', marginBottom: 'auto' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 8 : 6,
                height: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    let itemTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }

    let listItemProps = {
        component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />)
    };

    if (item.external) {
        listItemProps = { component: 'a', href: item.url, target: itemTarget };
    }

    const itemHandler = (id) => {
        dispatch({ type: MENU_OPEN, id });
        if (matchesSM) dispatch({ type: SET_MENU, opened: false });
    };

    // active menu item on page load
    useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === item.id);
        if (currentIndex > -1) {
            dispatch({ type: MENU_OPEN, id: item.id });
        }
    }, [pathname, item.id, dispatch]);

    return (
        <ListItemButton
            {...listItemProps}
            disabled={item.disabled}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onDragStart={(e) => e.preventDefault()} // prevent drag
            sx={{
                width: '240px',
                height: '40px',
                padding: '10px 15px',
                gap: '10px',
                borderRadius: '5px',
                mb: 0.5,
                marginBottom: '10px',
                alignItems: 'center',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                py: level > 1 ? 1 : 1.25,
                pl: `${level * 24}px`
            }}
            selected={customization.isOpen.findIndex((id) => id === item.id) > -1}
            onClick={() => itemHandler(item.id)}
        >
            <ListItemIcon
                sx={{
                    my: 'auto',
                    minWidth: !item.icon ? 18 : 22
                }}
            >
                {hover || customization.isOpen.includes(item.id) ? SelectedIcon : ItemIcon}
                {/* {customization.isOpen.findIndex((id) => id === item.id) > -1 ? SelectedIcon : ItemIcon} */}
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography
                        sx={{
                            display: 'flex',
                            height: '19px',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            flex: '1 0 0',
                            fontSize: '16px',
                            lineHeight: 'normal',
                            marginTop: customization.isOpen.findIndex((id) => id === item.id) > -1 ? '2px' : '2px' // Adjust vertical alignment
                            // fontWeight: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 700 : 400
                        }}
                        className={customization.isOpen.findIndex((id) => id === item.id) > -1 ? 'OpenSansBold' : 'OpenSansRegular'}
                    >
                        {item.title}
                    </Typography>
                }
                secondary={
                    item.caption && (
                        <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                            {item.caption}
                        </Typography>
                    )
                }
            />
            {item.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                />
            )}
        </ListItemButton>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;

// import PropTypes from 'prop-types';
// import { forwardRef, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// // material-ui
// import { useTheme } from '@mui/material/styles';
// import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';

// // project imports
// import { MENU_OPEN, SET_MENU } from 'store/actions';

// // assets
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// // ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

// const NavItem = ({ item, level }) => {
//     const theme = useTheme();
//     const dispatch = useDispatch();
//     const { pathname } = useLocation();
//     const customization = useSelector((state) => state.customization);
//     const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));

//     const SIcon = item.selected_icon;
//     const SelectedIcon = item.selected_icon ? (
//         <SIcon strokeWidth={1.5} size="1.3rem" style={{ marginTop: 'auto', marginBottom: 'auto', width: '22px', height: '22px' }} />
//     ) : (
//         <FiberManualRecordIcon
//             sx={{
//                 width: item === item.id ? 8 : 6,
//                 height: item === item.id ? 8 : 6
//             }}
//             fontSize={level > 0 ? 'inherit' : 'medium'}
//         />
//     );

//     const Icon = item.icon;
//     const itemIcon = item?.icon ? (
//         <Icon stroke={1.5} size="1.3rem" style={{ width: '22px', height: '22px' }} />
//     ) : (
//         <FiberManualRecordIcon
//             sx={{
//                 width: customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
//                 height: customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6
//             }}
//             fontSize={level > 0 ? 'inherit' : 'medium'}
//         />
//     );

//     let itemTarget = '_self';
//     if (item.target) {
//         itemTarget = '_blank';
//     }

//     let listItemProps = {
//         component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />)
//     };
//     if (item?.external) {
//         listItemProps = { component: 'a', href: item.url, target: itemTarget };
//     }

//     const itemHandler = (id) => {
//         dispatch({ type: MENU_OPEN, id });
//         if (matchesSM) dispatch({ type: SET_MENU, opened: false });
//     };

//     // active menu item on page load
//     useEffect(() => {
//         const currentIndex = document.location.pathname
//             .toString()
//             .split('/')
//             .findIndex((id) => id === item.id);
//         if (currentIndex > -1) {
//             dispatch({ type: MENU_OPEN, id: item.id });
//         }
//         // eslint-disable-next-line
//     }, [pathname]);

//     return (
//         <ListItemButton
//             {...listItemProps}
//             disabled={item.disabled}
//             sx={{
//                 width: '240px',
//                 height: '40px',
//                 padding: '10px 15px',
//                 gap: '10px',
//                 borderRadius: '5px',
//                 mb: 0.5,
//                 marginBottom: '10px',
//                 // alignItems: 'flex-start',
//                 alignItems: 'center',
//                 backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
//                 py: level > 1 ? 1 : 1.25,
//                 pl: `${level * 24}px`
//             }}
//             selected={customization.isOpen.findIndex((id) => id === item.id) > -1}
//             onClick={() => itemHandler(item.id)}
//         >
//             <ListItemIcon
//                 sx={{
//                     my: 'auto',
//                     minWidth: !item?.icon ? 18 : 22
//                 }}
//             >
//                 {customization.isOpen.findIndex((id) => id === item.id) > -1 ? SelectedIcon : itemIcon}
//             </ListItemIcon>
//             <ListItemText
//                 primary={
//                     <Typography
//                         variant={customization.isOpen.findIndex((id) => id === item.id) > -1 ? 'h5' : 'body1'}
//                         color="inherit"
//                         sx={{
//                             display: 'flex',
//                             height: '19px',
//                             flexDirection: 'column',
//                             justifyContent: 'center',
//                             flex: '1 0 0',
//                             fontSize: '16px',
//                             color: 'var(--primary, #03045E)',
//                             lineHeight: 'normal',
//                             marginTop: customization.isOpen.findIndex((id) => id === item.id) > -1 ? '2px' : '2px', // Adjust vertical alignment
//                             fontWeight: customization.isOpen.findIndex((id) => id === item.id) > -1 ? 700 : 400
//                         }}
//                     >
//                         {item.title}
//                     </Typography>
//                 }
//                 secondary={
//                     item.caption && (
//                         <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
//                             {item.caption}
//                         </Typography>
//                     )
//                 }
//             />
//             {item.chip && (
//                 <Chip
//                     color={item.chip.color}
//                     variant={item.chip.variant}
//                     size={item.chip.size}
//                     label={item.chip.label}
//                     avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
//                 />
//             )}
//         </ListItemButton>
//     );
// };

// NavItem.propTypes = {
//     item: PropTypes.object,
//     level: PropTypes.number
// };

// export default NavItem;
